import { useState } from "react";
import Post from "../../../helpers/ajax/post";
import ModelWrapper from "./ModelWrapper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const inputClass = "w-full block mb-3 rounded-md border focus:outline-none focus:ring-2 ring-offset-2 ring-black/30 px-3 py-2";
const formButtonClass = "bg-black mt-4 block text-white w-full p-3 font-bold rounded-md focus:outline-none focus:ring-2 ring-offset-2 ring-black/30";

const AddUnitExistingUser = (props) => {
    const { close, success, colony_id, initialEmail } = props;

    const [Email, setEmail] = useState(initialEmail || "");
    const [Unit, setUnit] = useState("");
    const [hasError, setHasError] = useState(null);

    const addUnit = async (ev) => {
        ev.preventDefault();
        try {
            await Post("/api/users/addUnit", {
                email: Email,
                unit: Unit,
                colony_id: colony_id,
            });
            toast("Unit added to existing user");
            success && success();
            close();
        } catch (error) {
            setHasError(error.error || "an error occurred");
        }
    };

    return (
        <ModelWrapper width={"w-96"} close={close} title={"Add Unit (Existing User)"}>
            <form onSubmit={addUnit} className="pt-4">
                <input value={Email} onChange={(e) => setEmail(e.target.value)} required placeholder="Email" type="email" className={inputClass} />
                <input value={Unit} onChange={(e) => setUnit(e.target.value)} required placeholder="Unit #" type="text" className={inputClass} />
                <button className={formButtonClass}>Add Unit</button>
                {!!hasError && <p className="text-red-800 text-left mt-4">{hasError}</p>}
            </form>
        </ModelWrapper>
    );
};

export default AddUnitExistingUser;